var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['app-container', _vm.focusColorClass]},[(_vm.isLoading)?_c('loading-screen'):_vm._e(),(!_vm.isLoading)?_c('slideshow-view',{class:{'app_creator-mode': _vm.isCreatorModeEnabled},attrs:{"is-creator-mode-enabled":_vm.isCreatorModeEnabled}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }